import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all duration-100 ease-in-out focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-sm hover:opacity-80 active:scale-[0.98]",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:opacity-80",
        outline:
          "border border-input bg-background hover:bg-[hsl(45,90%,50%,0.33)] hover:border-transparent",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:opacity-80",
        ghost: "hover-fade",
        link: "text-primary underline-offset-4 hover:underline",
        hero: "bg-primary text-primary-foreground shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/30 hover:opacity-80 active:scale-[0.98]",
      },
      size: {
        default: "h-8 px-4 pt-[7px] pb-2",
        sm: "h-8 px-4 pt-[7px] pb-2 text-sm",
        lg: "h-9 px-4 pt-[7px] pb-2 text-sm",
        icon: "h-8 w-8",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);